<template>
  <b-card
    :title="course.name"
    :img-src="domainUrl(course.imageUrl)"
    img-alt="Course Image"
    img-top
    tag="article"
    class="course-card"
  >
    <b-link
      :id="`popover-${course.courseId}`"
      class="text"
      v-html="course.description"
    />
    <b-popover
      custom-class="fixed-width-popover"
      :target="`popover-${course.courseId}`"
      variant="outline-secondary"
      triggers="hover"
      placement="top"
    >
      <span v-html="course.description" />
    </b-popover>
    <b-badge variant="secondary" class="p-1">
      <i class="fa-solid fa-dollar-sign"></i>
      {{ course.price }}
    </b-badge>
    <b-button
      :variant="course.inCart ? 'outline-primary' : 'primary'"
      size="sm"
      class="m-3"
      @click="toggleCart"
    >
      {{ course.inCart ? cart.out : cart.in }}
    </b-button>
  </b-card>
</template>

<script>
export default {
  name: "PublicCourseCard",
  props: {
    course: Object,
    domain: String,
    cart: Object,
  },
  methods: {
    toggleCart() {
      this.$emit("operateCart", this.course);
      this.$set(this.course, "inCart", !this.course.inCart);
    },
    domainUrl(path) {
      return `${this.domain}${path}`;
    }
  }
};
</script>

<style scoped>
.course-card {
  max-width: 30rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.text {
  /*width: 500px;*/
  /*overflow: hidden;*/
  /*white-space: nowrap;*/
  /*text-overflow: ellipsis;*/
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /*word-break: break-all;*/  /*注意这个文字多行很重要*/
  -webkit-box-orient: vertical;
}
</style>
